import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12 7.77L5.61 18h12.78z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 4L2 20h20L12 4zm0 3.77L18.39 18H5.61L12 7.77z"
})), 'ChangeHistoryTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ChangeHistoryTwoTone.js
// module id = 2737
// module chunks = 2